import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Endpoint } from '@app/constants/endpoints.constants';
import { UserEntitlementsData } from '@app/models/row-data.interface';
import { EligibilityData, EligibilityPeriod } from '@app/employees/models/eligibility-periods.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeesRepoService {
  constructor(private httpClient: HttpClient) {}

  getEmployeesData(): Observable<UserEntitlementsData[]> {
    return this.httpClient.get<UserEntitlementsData[]>(Endpoint.Employees);
  }

  getEligibilityData(username: string): Observable<EligibilityData> {
    return this.httpClient.get<EligibilityData>(`${Endpoint.Users}/${username}${Endpoint.Eligibility}`);
  }

  postEligibilityData(username: string, eligibilityPeriods: EligibilityPeriod[]): Observable<EligibilityData> {
    return this.httpClient.post<EligibilityData>(
      `${Endpoint.Users}/${username}${Endpoint.Eligibility}`,
      eligibilityPeriods
    );
  }

  updateEmployeeAccessLevel(sentRole: string, username: string): Observable<UserEntitlementsData> {
    return this.httpClient.patch<UserEntitlementsData>(
      `${Endpoint.UpdateRole}`,
      {},
      { params: { role: sentRole, username } }
    );
  }
}
